import {
    type UndoRedoBehaviorSpec,
    UNDO_REDO_BEHAVIOR_SPECS,
} from './UndoRedoBehaviorSpec';

/**
 * SolidWorks 撤销重做行为矩阵行。
 */
export interface SolidWorksUndoRedoMatrixRow {
    /** 场景名称。 */
    readonly scenario: string;
    /** SolidWorks 期望行为。 */
    readonly solidWorksExpectedBehavior: string;
    /** PuppyCAD 当前入口。 */
    readonly puppyCadEntry: string;
    /** 应进入的历史栈。 */
    readonly targetHistoryStack: UndoRedoBehaviorSpec['targetHistoryStack'];
    /** 行为类型，用于区分 preview 会话与最终目标历史栈。 */
    readonly behaviorKind: UndoRedoBehaviorSpec['historyKind'];
    /** 是否生成事务。 */
    readonly createsTransaction: boolean;
    /** redo 清理目标。 */
    readonly clearsRedoStack: UndoRedoBehaviorSpec['clearsRedoStack'];
    /** 是否需要测试。 */
    readonly requiresTest: boolean;
}

/**
 * 将行为规范转换为矩阵行。
 *
 * @param spec 行为规范。
 * @returns 矩阵行。
 */
function createMatrixRow(spec: UndoRedoBehaviorSpec): SolidWorksUndoRedoMatrixRow {
    return {
        scenario: spec.title,
        solidWorksExpectedBehavior: spec.solidWorksExpectedBehavior,
        puppyCadEntry: spec.puppyCadEntry,
        targetHistoryStack: spec.targetHistoryStack,
        behaviorKind: spec.historyKind,
        createsTransaction: spec.transactionTarget !== 'none',
        clearsRedoStack: spec.clearsRedoStack,
        requiresTest: spec.requiresTest,
    };
}

/**
 * SolidWorks 对齐矩阵。
 */
export const SOLIDWORKS_UNDO_REDO_MATRIX = UNDO_REDO_BEHAVIOR_SPECS.map(createMatrixRow);

/**
 * 查询所有必须测试的矩阵行。
 *
 * @returns 必须测试的矩阵行。
 */
export function listRequiredSolidWorksUndoRedoMatrixTests(): readonly SolidWorksUndoRedoMatrixRow[] {
    return SOLIDWORKS_UNDO_REDO_MATRIX.filter((row) => row.requiresTest);
}
